import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=2e1b3104&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=js&"
export * from "./NewPassword.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=2e1b3104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b3104",
  null
  
)

export default component.exports